import { type Country } from '@/shared/types/api.types'

export const useFindCountries = () => {
  const findCountries = (searchString: string, countries: Country[]) => {
    const searchLower = searchString.toLowerCase()
    let result: Country[] = []
    if (!searchLower) return countries

    const filterSearchString =
      countries.filter((nationality) =>
        nationality.searchString.toLowerCase().includes(searchLower)
      ) || []

    if (filterSearchString.length) {
      result = filterSearchString
    } else {
      result =
        countries.filter((nationality) => nationality.name.toLowerCase().includes(searchLower)) ||
        []
    }

    if (!result.length) return result

    return result.sort((nationality1, nationality2) => {
      if (nationality1.popular && nationality2.popular) {
        return Number(nationality1.popular) - Number(nationality2.popular)
      }
      if (nationality1.popular) return -1
      if (nationality2.popular) return 1
      return nationality1.name.localeCompare(nationality2.name)
    })
  }

  const sortCountries = (countries: Country[], priorityIds: string[]) =>
    countries.sort((countryA, countryB) => {
      const indexA = priorityIds.indexOf(countryA.id)
      const indexB = priorityIds.indexOf(countryB.id)
      const aInPriority = indexA !== -1
      const bInPriority = indexB !== -1
      if (aInPriority && bInPriority) return indexA - indexB
      if (aInPriority) return -1
      if (bInPriority) return 1
      return countryA.name.localeCompare(countryB.name)
    })

  return {
    findCountries,
    sortCountries,
  }
}
